import Box from "@mui/material/Box";
import { motion, useAnimation as useMotionAnimation } from "framer-motion";
import { useRef, useState } from "react";
import CoupleNameAndDate from "../components/CoupleNameAndDate";
import { useAnimation } from "../contexts/AnimationContext";

import { Container, TextField } from "@mui/material";
import Countdown from "../components/Countdown";

export default function Login({ onLogin }) {
  const [pw, setPw] = useState("");
  const [ok, setOk] = useState(false);
  const [placeholderText, setPlaceholderText] = useState("INSERIR SENHA");
  const { animationStarted } = useAnimation();
  const pwInputRef = useRef(null);
  const motionControls = useMotionAnimation();

  const handleChange = async (v) => {
    setPw(v);
    if (v === "isabelaetiago2026") {
      /* (document.elementFromPoint(0, 0) || document.body).dispatchEvent(
        new MouseEvent("click", {
          clientX: 0,
          clientY: 0,
          view: window,
          bubbles: true,
          cancelable: true,
          }),
          ); */

      // Scroll to top to avoid mobile keyboard overlapping content
      document.elementFromPoint(0, 0)?.scrollIntoView({ behavior: "smooth" });

      // wait a bit for better UX
      await new Promise((resolve) => setTimeout(resolve, 50));

      if (isMobile()) {
        // Blur the input field to close mobile keyboard
        pwInputRef.current?.blur();

        // wait a bit for better UX
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      // animate whole page (blur + fade) then notify parent
      await motionControls.start(
        { opacity: 0, filter: "blur(6px)", y: -6 },
        { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
      );

      // authentication successful
      setOk(true);
      if (onLogin) onLogin(true);
    } else {
      setOk(false);
    }
  };

  const isMobile = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width:600px)").matches;

  const handleFocus = () => {
    setPlaceholderText("");
    if (isMobile()) {
      setTimeout(() => {
        const el = pwInputRef.current;
        if (el && typeof el.scrollIntoView === "function") {
          try {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          } catch (e) {
            el.scrollIntoView();
          }
        }
      }, 0);
    }
  };

  const handleBlur = () => {
    setPlaceholderText("INSERIR SENHA");
    if (isMobile()) {
      setTimeout(() => {
        const loginEl = document.getElementById("login");
        if (loginEl && typeof loginEl.scrollIntoView === "function") {
          try {
            loginEl.scrollIntoView({ behavior: "smooth", block: "start" });
          } catch (e) {
            loginEl.scrollIntoView();
          }
        }
      }, 300);
    }
  };

  return (
    <Box
      component={motion.section}
      initial={{ opacity: 1, filter: "blur(0px)" }}
      animate={motionControls}
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        pt: 0,
        pb: 0,
        px: 2,
        mt: 0,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <CoupleNameAndDate />
          <Countdown />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 8 }}
              animate={animationStarted ? { opacity: 1, y: 0 } : {}}
              transition={{
                duration: 0.6,
                delay: 0,
                ease: [0.22, 1, 0.36, 1],
              }}
              sx={{
                width: { xs: "60%", sm: "75%", md: "75%", lg: "75%" },
                mt: 0,
              }}
            >
              <TextField
                inputRef={pwInputRef}
                type="password"
                value={pw}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={placeholderText}
                fullWidth
                variant="outlined"
                sx={{
                  bgcolor: "white",
                  borderRadius: "999px",
                  boxShadow: "0 1.5px 5px rgba(26,58,82,0.06)",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "999px",
                    backgroundColor: "white",
                    "& fieldset": { border: "none" },
                    "&:hover fieldset": { border: "none" },
                    "&.Mui-focused": {
                      boxShadow: "0 3px 8px rgba(26,58,82,0.06)",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    textAlign: "center",
                    fontSize: { xs: 20, sm: 30 },
                    px: 3,
                    py: { xs: "15px", sm: "20px" },
                    WebkitTextFillColor: "rgba(26,58,82,0.9)",
                    WebkitTextSecurity: "disc",
                    // fallback for other engines
                    textSecurity: "disc",
                    caretColor: "rgba(26,58,82,0.9)",
                    "&::placeholder": {
                      color: "rgba(26,58,82,0.1)",
                      fontSize: {
                        xs: "0.8rem",
                        sm: "1rem",
                      },
                      opacity: 1,
                      transform: {
                        xs: "translateY(-3px)",
                        sm: "translateY(-6px)",
                      },
                    },
                  },
                }}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
